import { ActionIcon, Box, Loader, Tooltip } from 'ui';
import { IconClose } from 'ui/Icons';

import { SearchableMultiSelectWithOptionData, SearchableSelectWithOptionData } from './types';

type SelectOptions = Pick<SearchableSelectWithOptionData, 'value' | 'onChange'>;
type MultiSelectOptions = Pick<SearchableMultiSelectWithOptionData, 'value' | 'onChange'>;

interface RightSectionProps {
  isLoading: boolean;
  value: SelectOptions['value'] | MultiSelectOptions['value'];
  onChange: () => void;
}

const RightSection = ({ isLoading, value, onChange }: RightSectionProps) => {
  if (!isLoading && !value?.length) return undefined;
  return (
    <Box data-testid="select-right-section">
      {isLoading ? (
        <Loader size="1.1rem" />
      ) : (
        <Tooltip label="Clear">
          <ActionIcon size="sm" variant="transparent" c="gray" onClick={() => onChange?.()}>
            <IconClose data-testid="right-section-clear-button" />
          </ActionIcon>
        </Tooltip>
      )}
    </Box>
  );
};

export { RightSection };
